import { Box, Grid, Heading } from '@simplywallst/ui-core';
import { DividendQualityForecastBarChart as BarChart } from '../../../DividendQualityForecastBarChart';
import { DividendQualityForecastTooltip as ToolTip } from '../../../DividendQualityForecastTooltip';
import { DividendQualityForecastTable as Table } from '../../../DividendQualityForecastTable';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

interface Props {
  portfolio: Portfolio;
}

export const DividendQualityForecast = ({ portfolio }: Props) => {
  return (
    <Box padding="x1" paddingMd="x3" backgroundColor="noir" borderRadiusLg="x1">
      <Grid templateColumns="100%" templateColumnsLg="1fr 1fr" gap="24px">
        <div>
          <Box padding="x1" paddingMd="x0">
            <Heading as="h3" typography="xLargeStrong" color="textSolid">
              Dividend Quality & Forecast
            </Heading>
          </Box>
          <Box paddingTop="x1" paddingTopMd="x2">
            <ToolTip />
          </Box>

          <BarChart />
        </div>
        <div>
          <Table portfolio={portfolio} />
        </div>
      </Grid>
    </Box>
  );
};
